import React from 'react'
import { Search as SearchIcon } from '@mui/icons-material'
import { SearchbarProps } from './Searchbar.interface'
import './Searchbar.styles.css'

export const Searchbar = (props: SearchbarProps) => {
  return (
    <div className='searchbar'>
      <input placeholder='Search' type='text' {...props} />
      <button className='button-search'>
        <SearchIcon />
      </button>
    </div>
  )
}
